import { render, staticRenderFns } from "./masterPartnerDataValue.vue?vue&type=template&id=cca6f142&scoped=true"
import script from "./masterPartnerDataValue.vue?vue&type=script&lang=js"
export * from "./masterPartnerDataValue.vue?vue&type=script&lang=js"
import style0 from "./masterPartnerDataValue.vue?vue&type=style&index=0&id=cca6f142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca6f142",
  null
  
)

export default component.exports